import { render, staticRenderFns } from "./STablePaymentsCloseBoxComp.vue?vue&type=template&id=a13a3a28&"
import script from "./STablePaymentsCloseBoxComp.vue?vue&type=script&lang=js&"
export * from "./STablePaymentsCloseBoxComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports